import { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { chartNames, strCode } from "../../../../consts";
import { dashboardUtil, rumEventsUtil } from "../../../../utils";
import { useSelectedAppTypes } from "../../../../hooks";

import { DashboardBarChart, DashboardLineChart } from "../../../../components";
import { DashboardTemplate } from "../../../../templates";
import { GridItem } from "../styled";

const BatteryHealthSection = ({
  getChartFilter = () => {},
  getIsLoading = () => {},
  getIsError = () => {}
}) => {
  const batteryHealth = useSelector((store) => store.rum.batteryHealth);

  const selectedAppTypes = useSelectedAppTypes();

  const batteryHealthPerformanceData = useMemo(() => {
    return batteryHealth?.performance?.some((performance) =>
      Object.values(performance.metrics).some((value) => value > 0)
    )
      ? batteryHealth?.performance
      : [];
  }, [batteryHealth?.performance]);

  return (
    <>
      {dashboardUtil.isChartAvailable(selectedAppTypes, chartNames.BATTERY_HEALTH_STATISTICS) && (
        <GridItem gridColumn={"1 / 7"}>
          <DashboardTemplate
            id={chartNames.BATTERY_HEALTH_STATISTICS}
            title={strCode.BATTERY_HEALTH_STATISTICS_TITLE}
            isLoading={getIsLoading(chartNames.BATTERY_HEALTH_STATISTICS)}>
            <DashboardBarChart
              data={batteryHealth?.statistics}
              isLoading={getIsLoading(chartNames.BATTERY_HEALTH_STATISTICS)}
              isError={getIsError(chartNames.BATTERY_HEALTH_STATISTICS)}
              yAxisLabel={strCode.COUNT_LABEL}
              metricsConfig={rumEventsUtil.getMetricsConfig({
                chartName: chartNames.BATTERY_HEALTH_STATISTICS,
                deviceType: getChartFilter(chartNames.BATTERY_HEALTH_STATISTICS)
              })}
            />
          </DashboardTemplate>
        </GridItem>
      )}

      {dashboardUtil.isChartAvailable(selectedAppTypes, chartNames.BATTERY_HEALTH_PERFORMANCE) && (
        <GridItem gridColumn={"1 / 7"}>
          <DashboardTemplate
            id={chartNames.BATTERY_HEALTH_PERFORMANCE}
            title={strCode.BATTERY_HEALTH_PERFORMANCE_TITLE}
            isLoading={getIsLoading(chartNames.BATTERY_HEALTH_PERFORMANCE)}>
            <DashboardLineChart
              data={batteryHealthPerformanceData}
              isLoading={getIsLoading(chartNames.BATTERY_HEALTH_PERFORMANCE)}
              isError={getIsError(chartNames.BATTERY_HEALTH_PERFORMANCE)}
              yAxisLabel={strCode.COUNT_LABEL}
              metricsConfig={rumEventsUtil.getMetricsConfig({
                chartName: chartNames.BATTERY_HEALTH_PERFORMANCE,
                deviceType: getChartFilter(chartNames.BATTERY_HEALTH_PERFORMANCE),
                coloredMetric: "batteryHealth"
              })}
            />
          </DashboardTemplate>
        </GridItem>
      )}
    </>
  );
};

BatteryHealthSection.propTypes = {
  getChartFilter: PropTypes.func.isRequired,
  getIsLoading: PropTypes.func.isRequired,
  getIsError: PropTypes.func.isRequired
};

export default BatteryHealthSection;
